export default "__VITE_ASSET__NdaM9oeG__"